export const RISK_REVIEW_STATUS_CONFIG = {
  DRAFT: { label: "Draft", colorScheme: "gray" },
  SUBMITTED: { label: "Submitted", colorScheme: "blue" },
  PENDING_APPROVAL: { label: "Pending Approval", colorScheme: "orange" },
  APPROVED: { label: "Approved", colorScheme: "green" },
  REJECTED: { label: "Rejected", colorScheme: "red" },
  WITHDRAWN: { label: "Withdrawn", colorScheme: "gray" },
  CANCELLED: { label: "Cancelled", colorScheme: "gray" },
};

export const RISK_REVIEW_TEMPLATE_STATUS_CONFIG = {
  DRAFT: { label: "Draft", colorScheme: "gray" },
  PUBLISHED: { label: "Published", colorScheme: "green" },
  INACTIVE: { label: "Inactive", colorScheme: "orange" },
  ARCHIVED: { label: "Archived", colorScheme: "gray" },
};

export const RISK_SEVERITY_CONFIG = {
  CRITICAL: { label: "Critical", colorScheme: "red" },
  HIGH: { label: "High", colorScheme: "red" },
  MEDIUM: { label: "Medium", colorScheme: "orange" },
  LOW: { label: "Low", colorScheme: "green" },
};
